import React from 'react';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <ContactSection />
    </div>
  );
};

export default ContactPage;
